import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';

import { ShowcaseService } from 'src/app/core/services/showcase/showcase.service';
import { HostListener } from '@angular/core';
import { Location } from '@angular/common';
import { distinctUntilChanged, filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthenticationService } from 'src/app/core/services/Authentication/authentication.service';
declare var bootstrap: any;

@Component({
  selector: 'app-showcase',
  templateUrl: './showcase.component.html',
  styleUrls: ['./showcase.component.scss'],
})
export class ShowcaseComponent implements OnInit, OnDestroy {
  moviesListCategory: any;
  objectKeys = Object.keys;
  searchIcon: any = 'assets/images/cinejoy/Search.png';
  leftArrow: any = 'assets/images/cinejoy/arrow-left.png';
  filterMovieList: any;
  catSub: any;
  orignalFilterMovieList: any[] = [];
  smoothScroll: (elem: any, offset?: number) => Promise<unknown>;
  movieDisplayed: any;
  BackgroundImage: any;
  DazzlermovieList: any;
  GoodTimesmovieList: any;
  IlluminationmovieList: any;
  InspirationmovieList: any;
  LaughsmovieList: any;
  LovemovieList: any;
  ThrillsmovieList: any;
  MindBendersmovieList: any;
  AnimationmovieList: any;
  ComedymovieList: any;
  CrimemovieList: any;
  DocumentarymovieList: any;
  DramamovieList: any;
  FantasymovieList: any;
  RomanticComedymovieList: any;
  HorrormovieList: any;
  SciFimovieList: any;
  ThrillermovieList: any;
  loadFalse: boolean = false;
  private destroy$ = new Subject<void>();
  movieCopy:any;
  isSearched:boolean=false;
  isMobileLoading:boolean=true;
  currentSelectedIndex:any=0;

  constructor(
    public router: Router,
    private showcaseService: ShowcaseService,
    private scroller: ViewportScroller,
    private _location: Location,
    private authService:AuthenticationService
  ) { 
    this.router.events
    .pipe(
      filter((event) => event instanceof NavigationEnd),
      distinctUntilChanged((prev: any, curr: any) => prev.url === curr.url),
      takeUntil(this.destroy$)
    )
    .subscribe(() => {
      this.ngOnInit();
    });
  }
  id: any;
  Isshow: boolean = false;
  moviesArray: any[] = [];
  searchBox: any = '';
  movieList: any = [];
  shorts: any = [];
  feature: any = [];
  categorySelected: boolean = false;
  showcaseItems: any;
  FeaturemovieList: any = [];
  ShortsmovieList: any = [];
  moviesCollection: any = [];
  categories: any = [];
  subCategories: any = [];
  subct: any;
  cat: any;
  ThrillersubCategories: any = [];
  FeaturesubCategories: any = [];
  ShortssubCategories: any = [];
  sub: any = [];
  features: any = [];
  AllmovieList: any = [];
  name: any;
  secondaryNav = false;
  i: any;
  filtermovieList: any[];
  featureSub: any = 'Features';
  catGen: any;
  genre: any;
  btnVal = 'Feature >';
  headingVal = 'Showcase';
  headingVal1 = 'Shorts >';
  btnVal1 = 'Shorts >';
  activeCategory: string;
  public isCollapsed: boolean = false;
  display: boolean;
  display1: boolean;
  show: boolean;
  selectedMovieId: string;
  routerSubscription:any;
  ngOnInit(): void {
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.closeAllModals();
      }
    });
    this.authService.checkUserAuthenticated().subscribe((res)=>{
      if(res.userId > 0){
        this.showcaseService.fetchTickets();
      }
    }, err=>{
      console.log(err);
    })
    this.activeCategory = this.router.url.split('/')[2];
    const urlSegments = this.router.url.split('/');
    const categoryType = urlSegments[3];
  
    if (["emotion", "genre", "features", "shorts"].includes(categoryType) || this.router.url.includes('/archive')) {
      this.categorySelected = true;
  
      const sessionData = sessionStorage.getItem('movieNavigation');
      this.featureSub = sessionStorage.getItem('type') || 'Features';
  
      if (sessionData) {
        const item = JSON.parse(sessionData);
        this.cat = item.category;
        this.subct = item.subCategories;
        this.getMoviesByCategory(item.category, item.subCategories);
      } else {
        this.initializeCategoryAndType(urlSegments);
      }
  
    //  this.getMoviesByCategory(this.cat, this.subct);
    }
  
    if (this.router.url === '/cinejoy/showcase/archive') {
      this.categorySelected = false;
    }
  
    if (this.router.url === '/cinejoy/showcase/archive' || this.router.url === '/cinejoy/showcase') {
      this.getShowcases();
    }

    this.getShowcaseList();
  
    this.showcaseService.scrollObs$.subscribe((res) => {
      this.selectedMovieId = res.replace('movies', '');
    });
  
    this.loadFalse = this.checkMobileView();
  
   this.getShortsMovieList();
   this.getFeaturesList();
   this.subcatClick();
  }
  sortMovies(array: any[], field: string, order: 'asc' | 'desc' = 'asc'): any[] {
    return array.slice().sort((a, b) => {
      const comparison = a[field].localeCompare(b[field]);
      return order === 'asc' ? comparison : -comparison;
    });
  }

  getShowcaseList() {
    this.showcaseService.getShowcaseList().subscribe((res) => {
      this.AllmovieList = res;
      this.moviesListCategory = this.AllmovieList.flatMap(
        (ele) => ele.emotions
      );
      // this.moviesCollection = new Set(this.moviesListCategory);
    });
    this.showcaseService.scrollObs$.subscribe((res) => {
      this.selectedMovieId = res.replace('movies', '');
    });
  }

  
  getShowcases() {
      // cms data
      this.showcaseService.getCinejoyAdminShowcasesList().subscribe((res) => {
        this.showcaseItems = res;
        this.movieList = res.moviesArray;
        this.categories = res.categories;
        this.subCategories = res.subCategories;
        if(this.checkMobileView()){
          this.getItemBasedOnCategoryForMobileView()
        }
        //this.movieDisplayed = this.movieList[0];
      });
        
  }
  backClicked() {
    this._location.back();
  }

  mobilebackClicked() {
    this.router.navigate(['/cinejoy'])
  }

  //button click function
  changeText() {
    this.btnVal = '';
    this.btnVal1 = '';
    this.headingVal = 'Features';
    this.display = !this.display;
    this.Isshow = true;
  }
  changeText1() {
    this.headingVal = 'Shorts';
    this.display = !this.display;
    this.Isshow = true;
  }

 
  toggle() {
    this.display = !this.display;
  }
  toggle1() {
    this.display1 = !this.display1;
  }
  @ViewChild('scroll') scroll: ElementRef;
  scrollTop() {
    this.scroll.nativeElement.scrollTop = 0;
  }
  search(event): void {
    const input = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (input.length > 1) {
      this.filterMovieList = this.movieCopy.filter((movie) =>
        movie.name.toLowerCase().includes(input.toLowerCase())
      );
    } else {
      this.filterMovieList = [...this.movieCopy];
    }
  }
  subcatClick() {
    if (this.router.url === '/cinejoy/showcase/genre' || this.router.url === '/cinejoy/showcase/emotion') {
      // cms data
      this.showcaseService
        .getCinejoyAdminShowcaseMoviesByCategories(this.cat, this.subct, this.featureSub)
        .subscribe(
          (res) => {
            res.moviesArray = this.sortMovies(res.moviesArray,'name','asc')
            this.filterMovieList = res.moviesArray;
            this.movieCopy = this.filterMovieList;
            let obj = {
              subCategories: this.subct,
              category: this.cat,
              type: this.featureSub,
            };
            this.showcaseService.categoryObs$?.next(JSON.stringify(obj));
            this.showcaseService.scrollObs$?.next(
              `movies${res.moviesArray[0]?.id}`
            );
            this.selectedMovieId = res.moviesArray[0]?.id;
            sessionStorage.setItem('movieNavigation', JSON.stringify(obj));
            if (this.router.url.includes('/archive')) {
              this.router.navigateByUrl(`/cinejoy/showcase/archive/${obj.category}`);
            } else {
              this.router.navigateByUrl(`/cinejoy/showcase/${obj.category}`);
            }
          },
          (err) => { }
        );
    } 
    else if(this.router.url === '/cinejoy/showcase/genre' || this.router.url === '/cinejoy/showcase/emotion') {
      // Agiletix data
      this.showcaseService
        .getMoviesByCategories(this.cat, this.featureSub, this.subct)
        .subscribe(
          (res) => {
            this.filterMovieList = res.moviesArray;
            this.movieCopy = this.filterMovieList;
            let obj = {
              subCategories: this.subct,
              category: this.cat,
              type: this.featureSub,
            };
            this.showcaseService.categoryObs$?.next(JSON.stringify(obj));
            this.showcaseService.scrollObs$?.next(
              `movies${res.moviesArray[0]?.id}`
            );
            this.selectedMovieId = res.moviesArray[0]?.id;
            sessionStorage.setItem('movieNavigation', JSON.stringify(obj));
            if (this.router.url.includes('/archive')) {
              this.router.navigateByUrl(`/cinejoy/showcase/archive/${obj.category}`);
            } else {
              this.router.navigateByUrl(`/cinejoy/showcase/${obj.category}`);
            }
          },
          (err) => { }
        );
    }


    else if(this.router.url === '/cinejoy/showcase/features' || this.router.url === '/cinejoy/showcase/archive/features' || this.router.url.includes('session_id')){
      this.selectedCategory('nil', 'features')
    }


    else if(this.router.url === '/cinejoy/showcase/shorts' || this.router.url === '/cinejoy/showcase/archive/shorts' || this.router.url.includes('session_id')){
      this.selectedCategory('nil', 'shorts')
    }
  }
  featureClick() {
    if (this.featureSub === 'Feature') {
      this.filterMovieList = this.AllmovieList.filter(
        (movie) => movie.emotions.includes(this.subct) && movie.isFeature
      );
      this.movieCopy = this.filterMovieList;
      this.orignalFilterMovieList = this.filterMovieList;
    } else {
      this.filterMovieList = this.AllmovieList.filter(
        (movie) => movie.emotions.includes(this.subct) && movie.isShorts
      );
      this.movieCopy = this.filterMovieList;
      this.orignalFilterMovieList = this.filterMovieList;
    }
  }
  selectedCategory(subcat, category) {
    this.subct = subcat;
    this.cat = category;
    this.categorySelected = true;
    this.show=false;
    this.secondaryNav = false;
    this.featureSub = this.featureSub;
    if (subcat == 'nil' && category == 'features') {
      this.featureSub = 'Features';
    } else if (subcat == 'nil' && category == 'shorts') {
      this.featureSub = 'Shorts';
    }

        //cms data
        this.showcaseService
        .getCinejoyAdminShowcaseMoviesByCategories(category, subcat, this.featureSub)
        .subscribe(
          (res) => {
            res.moviesArray = this.sortMovies(res.moviesArray,'name','asc')
            this.filterMovieList = res.moviesArray;
            this.movieCopy = this.filterMovieList;
            if (res.moviesArray.length) {
              this.showcaseService.scrollObs$?.next(
                `movies${res.moviesArray[0].id}`
              );
              this.selectedMovieId = res.moviesArray[0].id;
            }
            this.moviesCollection = res.subcat;
          },
          (err) => {
            console.log(err);
          }
        );
      

    let obj = {
      subCategories: this.subct,
      category: this.cat,
      type: this.featureSub,
    };
    sessionStorage.setItem('movieNavigation', JSON.stringify(obj));
    this.showcaseService.categoryObs$.next(JSON.stringify(obj));
     if(this.router.url.includes('session_id')){
      // we not updating route url as callback url capture the specific catagory while starting the purchase
     }
      else{
        this.router.navigateByUrl(`/cinejoy/showcase/${category}`);
      }
    
  }

  selectedGenre(subcat, category) {
    this.genre = subcat;
    this.catGen = category;
    this.categorySelected = true;
    this.filterMovieList = this.AllmovieList.filter(
      (movie) => movie.emotions.includes(this.subct) && movie.isFeature
    );
    this.movieCopy = this.filterMovieList;
    this.orignalFilterMovieList = this.filterMovieList;
  }

  toggleNav(flag: boolean): void {
    this.secondaryNav = flag;
    this.show =flag;
    this.searchBox = '';
    if(!flag){
    this.filterMovieList = this.movieCopy;
    }
  //  
  }

  isSecondarySideNavOpen: boolean;
  updateSecondarySideNavStatus($event: any): void {
    this.isSecondarySideNavOpen = $event;
    this.categorySelected = false;
  }

  prepareRoute(outlet: RouterOutlet): any {
    return (
      outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation
    );
  }

  setMenuNavDefault() {
    this.categorySelected = false;
    this.display = false;
    window.location.href = '/cinejoy/showcase';

 //     this.router.navigateByUrl('/cinejoy/showcase');
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.categorySelected = false;
    this.display = false;
    this.featureSub = 'Features';
  }

  findMovieById(event) {
    let value = `movies${event}`;
    this.selectedMovieId = event;
    this.movieDisplayed = event;
    this.showcaseService.scrollObs$.next(value);
  }

  getMoviesByCategory(category, subcat) {
        // cms data
        this.showcaseService
        .getCinejoyAdminShowcaseMoviesByCategories(category,this.featureSub, subcat)
        .subscribe(
          (res) => {
            this.filterMovieList = res.moviesArray;
            this.movieCopy = this.filterMovieList;
            if (res.moviesArray.length) {
              this.showcaseService.scrollObs$.next(
                `movies${res.moviesArray[0].id}`
              );
              this.selectedMovieId = res.moviesArray[0].id;
            }

            this.moviesCollection = res.subcat;
          },
          (err) => {
            console.log(err);
          }
        );
      
  }

  navigateShowcaseArchive(event) {
    this.categorySelected = false;
  }

  onChangeOfCategory() {
    if (this.router.url.includes('/cinejoy/showcase/emotion') || this.router.url.includes('/cinejoy/showcase/genre')) {
      sessionStorage.setItem('type', this.featureSub)
      return this.selectedCategory(this.subct, this.cat);
    }
    if (this.featureSub == 'Features') {
      this.cat = 'Features';
    } else if (this.featureSub == 'Shorts') {
      this.cat = 'Shorts';
    }
    sessionStorage.setItem('type', this.featureSub)
        // cms data
        this.showcaseService
      .getCinejoyAdminShowcaseMoviesByCategories(this.cat, 'nil', this.featureSub)
        .subscribe(
          (res) => {
            res.moviesArray =  this.sortMovies(res.moviesArray,'name','asc')  
            this.filterMovieList = res.moviesArray;
            this.filterMovieList = this.sortMovies(this.filterMovieList,'name','asc')
            this.movieCopy = this.filterMovieList;
            if (res.moviesArray.length) {
              this.showcaseService.scrollObs$.next(
                `movies${res.moviesArray[0].id}`
              );
              this.selectedMovieId = res.moviesArray[0].id;
            }
            this.moviesCollection = res.subcat;
          },
          (err) => {
            console.log(err);
          }
        );
      

    let obj = {
      subCategories: this.subct,
      category: this.cat,
      type: this.featureSub,
    };
    this.toggleNav(false)
    sessionStorage.setItem('movieNavigation', JSON.stringify(obj));
    this.showcaseService.categoryObs$.next(JSON.stringify(obj));
    if (this.featureSub == 'Features') {
      if(this.router.url.includes('/cinejoy/showcase/archive')){
        this.router.navigateByUrl('/cinejoy/showcase/archive/features')
      }else{
        this.router.navigateByUrl('/cinejoy/showcase/features')
      }

    } else if (this.featureSub == 'Shorts') {

      if(this.router.url.includes('/cinejoy/showcase/archive')){
        this.router.navigateByUrl('/cinejoy/showcase/archive/shorts')
      }else{
        this.router.navigateByUrl('/cinejoy/showcase/shorts')
      }
    }

  }
  newArray: any = [];
  searchThis(data: any) {
    if (data.length > 1) {
      this.isSearched=true
      this.AllmovieList = this.newArray.filter((movie) =>
        movie.name.toLowerCase().includes(data.toLowerCase())
      );
    }else{
      this.isSearched = false;
    } 
  }

  refreshPage() {
    this.AllmovieList = this.newArray;
    this.isSearched = false;
    this.currentSelectedIndex = this.currentSelectedIndex;
   // this.ngOnInit()
  }

  hideCategory() {
    this.categorySelected = false;
  }

  @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
    sessionStorage.clear()
  }

  getmovieName(moviename) {
    let name = moviename.replace(/[\s?]/g, '-');
    return name;
  }

  ngOnDestroy() {
    // screen.orientation.unlock();
    this.destroy$.next();
    this.destroy$.complete();
    this.show = false;
    this.toggleNav(false)
  }
  showcaseMobileMovieList: any = [];
  getItemBasedOnCategoryForMobileView() {
    let item = []
    this.isMobileLoading=true;
    let subcategory = ['features', 'shorts']
    this.showcaseItems.categories.forEach(element => {
      item[element.name] = {}
      element.subCategories.map((res) => {
        subcategory.map((subcategory) => {

          // cms data
          this.showcaseService.getCinejoyAdminShowcaseMoviesByCategories(element.name, res.name, subcategory)
            .subscribe(
              (list) => {
                if (subcategory == 'shorts') {
                  list.moviesArray.forEach(movie => {
                    item[element?.name][res?.name]?.moviesArray.push(movie);
                  });
                } else {
                  item[element.name][res.name] = list;
                }
              },
              (err) => {
                console.log(err);

              }
            );
        })
      })
    });
    this.showcaseMobileMovieList = item;
    setTimeout(()=>{
      this.extractMovies(this.showcaseMobileMovieList)
      this.isMobileLoading = false;
    }, 3000)
  }

  extractMovies(obj) {
    this.AllmovieList = [];
    this.newArray = []
    Object.keys(obj).forEach(categoryKey => {
      const category = obj[categoryKey];

      // Second loop: Iterate over subcategories (Dazzlers, Good Times, Animation, etc.)
      Object.keys(category).forEach(subCategoryKey => {
        const subCategory = category[subCategoryKey];

        if (subCategory.moviesArray) {
          subCategory.moviesArray.forEach(movie => {
            if (!this.newArray.find((v) => v.id === movie.id)) {
              this.newArray.push(movie); // ✅ Store only unique movies by ID
              this.AllmovieList.push(movie)
            }
          });
        }
      });
    });
  }

  getValue(value) {
    return this.sortMovies(value.moviesArray,'name','asc');
  }

  getDisplayValue(value){
    if(value.moviesArray.length){
      return true
    }else{
      return false;
    }
  }
  getShortsMovieList() {
        // cms data
        this.showcaseService
        .getCinejoyAdminShowcaseMoviesByCategories('Shorts', 'nil', 'Shorts').subscribe((res) => {
          this.shorts = res.moviesArray;
        })
  
  }

  getFeaturesList() {
        //cms data
        this.showcaseService
        .getCinejoyAdminShowcaseMoviesByCategories('Features', 'nil', 'Features').subscribe((res) => {
          this.feature = res.moviesArray;
        })

  }


  private initializeCategoryAndType(urlSegments: string[]): void {
    const categoryType = urlSegments[3];
    const subCategoryMap: Record<string, string> = {
      shorts: 'Shorts',
      features: 'Features',
      emotion: 'Dazzlers',
      genre: 'Comedy'
    };
  
    if (categoryType in subCategoryMap) {
      this.subct = subCategoryMap[categoryType];
      this.cat = categoryType;
      const obj = {
        subCategories: this.subct,
        category: this.cat,
        type: this.featureSub
      };
      sessionStorage.setItem('movieNavigation', JSON.stringify(obj));
      this.showcaseService.categoryObs$.next(JSON.stringify(obj));
      if (categoryType === 'emotion' || categoryType === 'genre') {
        this.selectedCategory(this.subct, this.cat);
      }
    }
  }
  
 private checkMobileView(): boolean {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];

  return toMatch.some((toMatchItem) => toMatchItem.test(userAgent));

}

  selectedIndexChangeItem(index){
    this.currentSelectedIndex = index;
  }

  @HostListener('window:resize', ['$event'])
  checkScreenSize() {
    if (window.innerWidth < 760) {
      this.categorySelected = false;
    }
  }
  
  closeAllModals() {
    const modals = document.querySelectorAll('.modal.show');
    modals.forEach(modal => {
      console.log('Closing modal:', modal);
      const modalInstance = bootstrap.Modal.getInstance(modal);
      if (modalInstance) {
        modalInstance.hide();
      }
    });
  }
  
}
